module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_red_04-bd4be6f001f8534486a37c418eedd715.svg";